import type { ImageUpdate } from '@domain/schemas/images.schema';
import { getRequestAuthPayload } from '@helpers/getRequestAuth';
import axios from 'axios';

const IMAGES_URI = 'images';

// The image PATCH handlers return no body (empty 200), so there is no response type to share yet
export const updateImage = async (data: ImageUpdate, id: string): Promise<void> => {
  const networkPayload = await getRequestAuthPayload({
    method: 'patch',
    url: `/${IMAGES_URI}/` + id,
    data,
  });

  const response = await axios(networkPayload);
  return response.data;
};
